import React from 'react';
import { Tree } from '../types/Tree';
import './TreeCard.css';

interface TreeCardProps {
  tree: Tree;
  onTreeSelect: (tree: Tree) => void;
}

const TreeCard: React.FC<TreeCardProps> = ({ tree, onTreeSelect }) => {
  return (
    <div className="tree-card" onClick={() => onTreeSelect(tree)}>
      <div className="tree-image-container">
        <div className="tree-image-wrapper">
          <img 
            src={tree.imageUrl} 
            alt={tree.name}
            className="tree-image"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent && !parent.querySelector('.tree-placeholder')) {
                const placeholder = document.createElement('div');
                placeholder.className = 'tree-placeholder';
                placeholder.textContent = '🌳';
                parent.appendChild(placeholder);
              }
            }}
          />
        </div>
        <h3 className="tree-name">{tree.name}</h3>
      </div>
      <div className="tree-info">
        <p className="tree-description">{tree.description}</p>
        <div className="tree-characteristics">
          <span className="characteristic">Height: {tree.characteristics.height}</span>
          {tree.characteristics.smell && (
            <span className="characteristic">Smell: {tree.characteristics.smell}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TreeCard;